var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/smallPause.d8ffb991.png","uri@2x": __webpack_public_path__ + "static/media/smallPause.517c2b71.png","uri@3x": __webpack_public_path__ + "static/media/smallPause.e8a5c4e3.png",
    width: 24,
    height: 24
});